'use strict';

angular.module('shiftTraderApp')

// This is a generic retry queue for security failures.  Each item is expected to expose two functions: retry and cancel.
  .factory('EventTrackingService', ['$log', function($log) {
    var eventList = [];
    var service = {
      addEvent: function(name, data) {
        if (eventList.length > 20) {
          eventList.shift();
        }
        eventList.push({
          name: name,
          data: data,
          ts: moment.utc().toISOString()
        });
      },
      getEvents: function(numEvents) {
        if (_.isUndefined(numEvents)) {
          return eventList;
        } else {
          return _.last(eventList, numEvents);
        }
      }
    };

    return service;
  }]);
